module.exports = __webpack_public_path__ + "static/media/inSelectArrowUp.a1b0647b.svg";